import { useEffect } from "react"
import { Outlet } from "react-router-dom"
import { useRouteMatches } from "@/components/layout/route-handle"
import { siteConfig } from "@/config/site"

/** Top-level route: keeps the browser tab title in sync with the deepest titled route. */
export function RootLayout() {
  const matches = useRouteMatches()
  const title = [...matches].reverse().find((match) => match.handle?.title)?.handle?.title

  useEffect(() => {
    document.title = title ? `${title} · ${siteConfig.product}` : siteConfig.product
  }, [title])

  return <Outlet />
}
